import { InfoItem } from "@/components/info-item";
import { displayUUID, formatAbsoluteCoordinates } from "@/shared";
import { formatTimestamp } from "../../lib/helpers";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";

const TrackPersistenceEventDetails = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (
    !selectedEvent ||
    selectedEvent.type !== ANNOTATION_TYPES.TRACK_PERSISTENCE
  ) {
    return null;
  }

  const pinCoordinates = formatAbsoluteCoordinates(
    selectedEvent?.pinCoordinates.relativeX,
    selectedEvent?.pinCoordinates.relativeY,
    selectedEvent.cameraImageWidth,
    selectedEvent.cameraImageHeight
  );

  return (
    <>
      <InfoItem label="Event type" value="Track Persistence Annotation" />
      <InfoItem
        label="Journey ID"
        copyValue={selectedEvent?.journeyId}
        value={displayUUID(selectedEvent?.journeyId)}
      />
      <InfoItem
        label="Order ID"
        value={displayUUID(selectedEvent.orderId)}
        copyValue={selectedEvent.orderId}
      />
      <InfoItem
        label="Annotation ID"
        value={selectedEvent.id ? displayUUID(selectedEvent.id) : undefined}
        copyValue={selectedEvent.id || undefined}
      />
      <InfoItem
        label="Timestamp"
        value={
          selectedEvent?.timestamp && formatTimestamp(selectedEvent?.timestamp)
        }
        copyValue={selectedEvent?.timestamp}
      />
      <InfoItem label="Pin coordinates (x,y)" value={pinCoordinates} />
      <InfoItem
        label="Camera image dimensions"
        value={`${selectedEvent?.cameraImageWidth}x${selectedEvent?.cameraImageHeight}`}
      />
      <InfoItem label="Camera ID" value={selectedEvent?.cameraId} />
      <InfoItem label="Calibration ID" value={selectedEvent?.calibrationId} />
      <InfoItem label="Note" value={selectedEvent.notes} />
    </>
  );
};

export default TrackPersistenceEventDetails;
